import { render, staticRenderFns } from "./guard.vue?vue&type=template&id=260bcef2&scoped=true"
import script from "./guard.vue?vue&type=script&lang=js"
export * from "./guard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260bcef2",
  null
  
)

export default component.exports